<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img data-src="/assets/manufacture/transmission/yangzhong/yz.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    Jiangsu Transmission Plant
                </div>
                <div class="manufacture-t2">
                    Located in Yangzhong, Zhenjiang City, Jiangsu Province, the plant was established in 2018, covering an area of 220,000 square meters.<br />
                    It specializes in manufacturing core automotive components such as hybrid DHT transmissions and new energy drive motors. Its main products include DHT‑1, 9DCT, and 135 kW electric drive axle assemblies.<br />
                    Since its launch, the plant has received numerous awards, many of its manufacturing processes are industry-leading.
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                9（H）DCT Assembly Line
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    
                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                EOL Test
                            </div>
                            <div class="destils">
                                ① Fully automatic test bench with availability over 95%.<br />
                                ② Integrated Siemens motors and HBM T12 high-precision sensors for full torque simulation.<br />
                                ③ Equipped with Discom ROTAS system for real-time NVH detection.<br />
                                ④ Integrated differential axle shafts and oil circulation control to improve uptime.<br />
                                ⑤ Test program with interlock and error-proofing functions.<br />
                                ⑥ Full performance test, real-time analysis and data recording for full lifecycle quality traceability.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz1-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                Assembly & Meshing
                            </div>
                            <div class="destils">
                                ① Realizes clutch assembly & P2 motor assembly.<br />
                                ② Workstation operation: clutch assembly & P2 motor assembly.<br />
                                ③ Technology applied: robotics, force control technology, spline meshing.<br />
                                ④ Technical highlights: The robot automatically grasps the clutch and P2 motor, and realizes multi-stage spline automatic meshing through force control.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz1-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                Cover Bolt Fastening & Assembly Line Transfer
                            </div>
                            <div class="destils">
                                ① Adopts multi-axis bolt tightening and line transfer process.<br />
                                ② Workstation operation: Cover bolt tightening and assembly line transfer.<br />
                                ③ Technology applied: Robotic automatic tightening, handling and line transfer.<br />
                                ④ Technical highlights: Adopts fully automatic robotic multi-axis tightening technology to improve tightening quality. Automatic position adjustment enhances efficiency and flexibility. Integrated line transfer operation reduces costs.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz1-3.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                Adhesive Application & Inspection
                            </div>
                            <div class="destils">
                                ① Adopts adhesive application and bead inspection process.<br />
                                ② Workstation operation: Housing adhesive application.<br />
                                ③ Technology applied: Servo-driven adhesive application, vision inspection + dark room.<br />
                                ④ Technical highlights: Equipped with X-Y servo slides for high-flexibility adhesive application, and conducts 100% visual inspection of adhesive beads to ensure bead quality.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz1-4.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                Flexible Press-Fitting of Oil Seal Positioning Seat & Line Transfer
                            </div>
                            <div class="destils">
                                ① Adopts flexible press-fitting of oil seal positioning seat and line transfer.<br />
                                ② Workstation operation: Housing adhesive application.<br />
                                ③ Technology applied: Servo-driven adhesive application, vision inspection + dark room.<br />
                                ④ Technical highlights: Equipped with X-Y servo slides for high-flexibility adhesive application, and conducts 100% visual inspection of adhesive beads to ensure bead quality.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz1-5.jpg" alt="">
                        </div>
                    </div>
                    
                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                Flexible Press-Fitting of Oil Pipe
                            </div>
                            <div class="destils">
                                ① Adopts flexible press-fitting process for oil pipes.<br />
                                ② Workstation operation: Flexible press-fitting of oil pipes.<br />
                                ③ Technology applied: Robotics, oil coating, press-fitting, visual error-proofing.<br />
                                ④ Technical highlights: Vision-guided robot automatically picks up oil pipes, applies oil, and press-fits them in place. Visual inspection of press-fitting status ensures assembly quality.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz1-6.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                Housing Closing & Press-Fitting
                            </div>
                            <div class="destils">
                                ① Adopts housing press-fitting, adhesive application and housing closing processes.<br />
                                ② Workstation operation: Housing adhesive application and transmission case closing.<br />
                                ③ Technology applied: Robotics, adhesive application, multi-axis housing closing.<br />
                                ④ Technical highlights: The robot automatically grabs the housing, performs press-fitting and adhesive application, and realizes housing closing by adopting floating technology.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz1-7.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                Fork & Piston Press-Fitting
                            </div>
                            <div class="destils">
                                ① Adopts automatic assembly of fork and piston.<br />
                                ② Workstation operation: Automatic press-fitting of fork and piston.<br />
                                ③ Technology applied: Robotics, oil coating, press-fitting and visual error-proofing.<br />
                                ④ Technical highlights: Two robots automatically apply oil to the piston, press-fit it in place, and conduct visual inspection on the press-fitting status to ensure the assembly quality.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz1-8.jpg" alt="">
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                DHT1 Line
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Armature shrink fitting
                            </div>
                            <div class="destils">
                                ① Adopts dual-motor cavity heating process for the housing.<br />
                                ② Rigid-arm lifting + rotary table feeding, with one-drive-two split heaters for simultaneous cavity thermal expansion; robot completes dual-armature synchronous press-fitting and three-sided internal circulating air cooling, ensuring high flexibility, continuity and advanced industry level.<br />
                                ③ Applies robotic flexible heating-shrink-fitting and cooling technology, solving the industry problems of shrink-fitting stability and automation.
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz2-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Housing press-fitting
                            </div>
                            <div class="destils">
                                ① The workpiece is gripped by the robot gripper and transferred to the slide table, which moves the housing to the press-fitting station for press-fitting. The robot then grips the workpiece again for transfer.<br />
                                ② The robot is equipped with a quick-change gripper assembly, the electric cylinder with a quick-change press head, and the slide table with a quick-change pallet assembly to enable rapid model switching. 
                                This greatly ensures precision, flexibility and compatibility, reaching an advanced level in the industry.
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz2-3.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Shaft system measurement and splicing
                            </div>
                            <div class="destils">
                                At the station, materials are manually loaded and parts are delivered by the turntable. The handling robot grips the workpiece together with the gripper and moves it to the inspection station, where measurement is completed with a displacement sensor. The assembly robot then grips the workpiece together with the gripper and places it into the housing to finish assembly.
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz2-4.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Robot tightening
                            </div>
                            <div class="destils">
                                At this station, the robot is equipped with an electric tightening spindle to perform automatic bolt tightening and automatic torque measurement, enabling rapid model switc.
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/yangzhong/yz2-5.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                EOL Test
                            </div>
                            <div class="destils">
                                ① Final test for assembled assemblies to eliminate defects.<br />
                                ② Simulate actual operation with I/O mechanism, perform NVH test to verify assembly quality.<br />
                                ③ Display 1: motor speed-torque curve, clutch pressure, gear, voltage, current, speed, torque.<br />
                                ④ Display 2: vibration sensor energy diagram & motor speed-torque curve for NVH status.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>



    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: 'Jiangsu Transmission Plant - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/manufacture/tr/yangzhong.html'
};

import { createApp } from 'vue';
import App from './yangzhong.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./yangzhong.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
